<style>
  .errorText {
    color: red
  }
  .button.large {
      padding-right: 4.55rem;
      margin-left: 0.5rem;
  }
</style>
<template>
  <div class="modal-window large split active">
    <overlay-scrollbars
      :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <form @submit.prevent="handleSubmit">
        <div class="grid-x split">

          <div class="cell large-6 flex-column">
            <div class="modal-window-header gray">
              <div class="modal-window-heading">
                <h3 class="icon-heading small">
                  <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
                    xlink:href="/static/sprites.svg#button-glyph-object"></use></svg></span>
                  <span class="icon-heading-title">
                    <span class="title">Opprett faktura</span>
                    <span class="subtitle" v-if="state.editableAs === 'underhand'">Underhåndssalg</span>
                  </span>
                </h3>
              </div>

              <fieldset v-if="state.editableAs === 'underhand'">
                <TheAutoCompleteInputButton containerClassName="cell medium-9" v-model.trim="form.objektdata.MottakerName"
                  name="MottakerName" :placeholder="'Velg kjøper...'" :label="'Kjøper'" required
                  v-validate="'required|min:1'" :onInputCallback="onKundeSearchInput"
                  :onSelectCallback="onKundeSearchSelected" :onResetCallback="onKundeSearchReset">
                  <div slot="item" slot-scope="props">
                    <strong>{{props.item.Kundenr}}</strong> {{props.item.full_name}}
                  </div>
                </TheAutoCompleteInputButton>
              </fieldset>
            </div>

            <div class="modal-window-body">
              <fieldset>
                <div class="grid-x grid-padding-x">
                  <template v-if="state.editableAs === 'underhand'">
                    <TheSelectInput containerClassName="cell medium-12" label="Auksjon" name="Auksjon" required
                                    v-validate="'required'" data-vv-validate-on="input"
                                    v-model="form.objektdata.Auksjon" :items="uhDropdown"/>
                  </template>

                  <div class="cell medium-12">
                    <template v-if="isAccounting">
                      <label for="Fakturadato">Fakturadato</label>
                      <div class="input-container">
                        <b-datepicker
                          :show-week-number="false"
                          :editable="false"
                          :first-day-of-week="1"
                          v-model="form.Fakturadato"
                          name="Fakturadato"
                          placeholder="Vis kalender..."
                          icon="calendar-today"
                          ref="Fakturadato"
                          id="Fakturadato">
                          <button class="button disabled" v-if="!form.Fakturadato"
                                  @click.prevent="$refs.Fakturadato.toggle()"><span>Slett dato</span></button>
                          <button class="button" v-else @click.prevent="form.Fakturadato = null"><span>Slett dato</span>
                          </button>
                        </b-datepicker>
                        <span class="glyph"><svg viewBox="0 0 44 44"><use
                          xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                      </div>
                    </template>

                    <label for="Forfallsdato">Forfallsdato</label>
                    <div class="input-container">
                      <b-datepicker
                        :show-week-number="false"
                        :editable="false"
                        :first-day-of-week="1"
                        :min-date="minDate"
                        v-model="form.Forfallsdato"
                        name="Forfallsdato"
                        placeholder="Vis kalender..."
                        icon="calendar-today"
                        ref="Forfallsdato"
                        id="Forfallsdato">
                        <button class="button disabled" v-if="!form.Forfallsdato"
                                @click.prevent="$refs.Forfallsdato.toggle()"><span>Slett dato</span></button>
                        <button class="button" v-else @click.prevent="form.Forfallsdato = null"><span>Slett dato</span>
                        </button>
                      </b-datepicker>
                      <span class="glyph"><svg viewBox="0 0 44 44"><use
                        xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                    </div>
                  </div>
                  <TheSelectInput containerClassName="cell medium-12" label="Betalingsmetode" name="PaymentMethod"
                                  required v-validate="'required'" data-vv-validate-on="input"
                                  v-model="form.PaymentMethod" :items="paymentMethodsDropdown">
                     <span slot="option" slot-scope="props">
                       {{props.option.label}}
                     </span>
                  </TheSelectInput>
                </div>
              </fieldset>
            </div>

            <div class="modal-window-footer">
              <div class="grid-x">
                <div class="cell medium-2">
                  <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()"
                     class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                  <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                </div>
                <div class="cell medium-10">
                  <template>
                    <div>
                      <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonAndDliverClick()"
                         class="button primary submit large">Opprett faktura og utlever</a>
                      <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large"
                         disabled>Opprett faktura og utlever</a>
                      <a v-if="$store.getters.isFormProcessing && deliverButton" href="javascript:;"
                         class="button primary submit large loading">Opprett faktura og utleverer...<span
                        class="loader-spinner"></span></a>
                      <a v-if="$store.getters.isFormProcessing && !deliverButton" href="javascript:;" class="button primary submit large"
                         disabled>Opprett faktura og utlever</a>
                    </div>

                    <div>
                      <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()"
                         class="button primary submit large">Opprett faktura</a>
                      <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large"
                         disabled>Opprett faktura</a>
                      <a v-if="$store.getters.isFormProcessing && !deliverButton" href="javascript:;"
                         class="button primary submit large loading">Oppretter faktura...<span
                        class="loader-spinner"></span></a>
                      <a v-if="$store.getters.isFormProcessing && deliverButton" href="javascript:;" class="button primary submit large"
                         disabled>Opprett faktura</a>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="cell large-6 flex-column">
            <div class="modal-window-body">
              <TheLoader v-if="loadingKunde" :active="true"/>
              <TheEmptyList
                v-if="!loadingKunde && !form.objektdata.MottakerObject.Kundenr && state.editableAs === 'underhand'"
                :title="'Velg en kjøper først...'" :large="false" :icon="'button-glyph-person'"/>
              <TheEmptyList
                v-if="!loadingKunde && !form.objektdata.MottakerObject.Kundenr && state.editableAs !== 'underhand'"
                :title="'Objekt mangler en kjøper...'" :large="false" :icon="'button-glyph-person'"/>

              <template v-if="!loadingKunde && form.objektdata.MottakerObject.Kundenr">
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">
                    <h3>Kjøper: {{form.objektdata.MottakerObject.full_name}}</h3>
                  </div>
                </div>
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">&nbsp;</div>
                </div>

                <div class="grid-x grid-padding-x" v-bind:class="{errorText: !invoiceAddress}">
                  <div class="cell medium-9">
                    Fakturadresse
                  </div>
                  <div class="cell medium-3 align-right">
                    <span v-if="invoiceAddress">Ok</span>
                    <span v-else style="font-size:0.6em;">Adresse mangler</span>
                  </div>
                  <div class="cell medium-12">
                    {{form.objektdata.MottakerObject.full_address_fak}}
                  </div>
                </div>
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">&nbsp;</div>
                </div>

                <div class="grid-x grid-padding-x" v-bind:class="{errorText: !postAddress}">
                  <div class="cell medium-9">
                    Leveringsadresse
                  </div>
                  <div class="cell medium-3 align-right">
                    <span v-if="postAddress">Ok</span>
                    <span v-else style="font-size:0.6em;">Adresse mangler</span>
                  </div>
                  <div class="cell medium-12">
                    {{form.objektdata.MottakerObject.full_address_lev}}
                  </div>
                </div>
                <div class="grid-x grid-padding-x">
                  <div class="cell medium-12">&nbsp;</div>
                </div>

                <div class="grid-x grid-padding-x">
                  <div class="cell medium-7"></div>
                  <div class="cell medium-5">
                    <a href="javascript:;" @click="openKundeModal()" class="button secondary submit large">Rediger
                      adresser</a>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16">
            <use xlink:href="/static/sprites.svg#button-glyph-close"></use>
          </svg>
        </a>
      </form>
    </overlay-scrollbars>
  </div>
</template>

<script>
import KundeService from '@/services/KundeService'
import ObjektService from '@/services/ObjektService'
import AuksjonService from '@/services/AuksjonService'
import TheAutoCompleteInputButton from '../Inputs/TheAutoCompleteInputButton'
import bus from '@/plugins/event-bus'
import accounting from 'accounting-js'
import moment from 'moment'
import {getPaymentMethodsDropdown} from '../../helpers/Constants'
import {showBilagEmailPdfModal} from '../../helpers/ModalHelpers'

export default {
  name: 'KundeKontraktObjektTabKjoperBilagModal',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInputButton
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    },
    lines: {
      type: Array,
      required: true
    }
  },
  data () {
    const today = new Date()

    return {
      form: {
        Fakturadato: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        Forfallsdato: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 10),
        PaymentMethod: null,
        objektdata: {
          Mottaker: null,
          MottakerName: null,
          MottakerObject: {},
          Salgspris: this.objekt.Salgspris,
          Auksjon: null
        }
      },
      // minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      uhDropdown: [],
      vatDropdown: [],
      paymentMethodsDropdown: getPaymentMethodsDropdown(),
      loadingKunde: false,
      loaded: 0,
      deliverButton: null
    }
  },
  created () {
    bus.$off('kunde-address-updated')

    this.setFormLoading(true)
    this.setup()
    this.fetch()
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()

    bus.$on('kunde-address-updated', (data) => this.onKundeAddressUpdated(data))
  },
  watch: {
    loaded: function (newVal) {
      if (newVal === 1) {
        this.setFormLoading(false)
      }
    }
  },
  computed: {
    isAccounting: function () {
      return this.hasAccess('accounting')
    },
    minDate: function () {
      const today = new Date()

      return this.isAccounting ? null : new Date(today.getFullYear(), today.getMonth(), today.getDate())
    },
    invoiceAddress: function () {
      if (!this.form.objektdata.MottakerObject) {
        return null
      }

      if (!this.form.objektdata.MottakerObject.kundeadresse || this.form.objektdata.MottakerObject.kundeadresse.length < 1) {
        return null
      }

      return this.form.objektdata.MottakerObject.kundeadresse.filter(i => i.Type === 'faktura')
    },
    postAddress: function () {
      if (!this.form.objektdata.MottakerObject) {
        return null
      }

      if (!this.form.objektdata.MottakerObject.kundeadresse || this.form.objektdata.MottakerObject.kundeadresse.length < 1) {
        return null
      }

      return this.form.objektdata.MottakerObject.kundeadresse.filter(i => i.Type === 'levering')
    },
    isValidForSave: function () {
      if (!this.form.objektdata.MottakerObject.Kundenr) {
        return false
      }

      if (!this.invoiceAddress || !this.postAddress) {
        return false
      }

      return true
    }
  },
  methods: {
    setup: function () {
      if (this.state.editableAs === 'normal') {
        if (this.objekt.mottaker) {
          this.form.objektdata.Mottaker = this.objekt.mottaker.Kundenr
          this.form.objektdata.MottakerName = this.objekt.mottaker.full_name
          this.form.objektdata.MottakerObject = this.objekt.mottaker
        }
      } else {
        let found = this.lines.find(x => x.Varenr === this.objekt.Objektnr)

        if (found && found.Belop) {
          this.form.objektdata.Salgspris = accounting.formatNumber(found.Belop, {precision: 2, thousand: ''})
        } else {
          this.form.objektdata.Salgspris = 0.00
        }
      }

      if (this.state.editableAs === 'underhand') {
        if (this.objekt.mottaker) {
          this.form.objektdata.Mottaker = this.objekt.mottaker.Kundenr
          this.form.objektdata.MottakerName = this.objekt.mottaker.full_name
          this.form.objektdata.MottakerObject = this.objekt.mottaker
        }
      }
    },
    fetch: function () {
      // Load dropdown for underhand auksjon
      this.uhDropdown = []
      this.uhDropdown.push({key: null, val: 'Laster...'})

      AuksjonService.latestUnderhand(this.objekt.Avdelingsid)
        .then((response) => {
          this.uhDropdown = []
          this.uhDropdown.push({key: this.form.objektdata.Auksjon, val: 'Velg auksjon', disabled: true})

          response.data.forEach((x) => {
            // Make first item selected
            if (!this.form.objektdata.Auksjon) {
              this.form.objektdata.Auksjon = x.Auksjon
            }

            this.uhDropdown.push({key: x.Auksjon, val: x.Beskrivelse})
          })
        })
        .catch((e) => {
          console.log(e)
        })
        .then(() => {
          ++this.loaded
        })
    },
    onKundeSearchReset: function () {
      this.form.objektdata.Mottaker = null
      this.form.objektdata.MottakerName = null
      this.form.objektdata.MottakerObject = {}
    },
    onKundeSearchInput: function (query) {
      return KundeService.search(query)
    },
    onKundeSearchSelected: function (item) {
      if (item) {
        this.form.objektdata.Mottaker = item.Kundenr || null
        this.form.objektdata.MottakerName = item.full_name || ''

        if (this.form.objektdata.Mottaker) {
          this.loadingKunde = true

          KundeService.view(this.form.objektdata.Mottaker)
            .then((response) => {
              this.form.objektdata.MottakerObject = response.data

              this.$validator.validate('MottakerName')
            })
            .catch((e) => {
              this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn mottaker')
              this.onKundeSearchReset()
            })
            .then(() => {
              this.loadingKunde = false
            })
        } else {
          this.form.objektdata.MottakerObject = {}
        }
      }
    },
    onKundeAddressUpdated: function (data) {
      this.$helpers.showSuccessAlert('Kjøper er lagret')

      let item = this._.cloneDeep(this.objekt)
      item.mottaker = Object.assign({}, item.mottaker, data)

      this.form.objektdata.MottakerObject = item.mottaker

      if (this.state.editableAs !== 'underhand') {
        // Send event to root - to update objekt
        bus.$emit('kunde-kontrakt-objekt-updated', item)
      }
    },
    openKundeModal: function () {
      this.openModal(
        'kunde-adresse-modal',
        {
          kunde: this.form.objektdata.MottakerObject,
          event: 'kunde-address-updated'
        }
      )
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    submitButtonAndDliverClick: function () {
      this.handleSubmit(true)
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    makePostData: function () {
      let omitInLine = [
        'Bilagslinjeid',
        'Bilagsid',
        'Linjenr',
        'Utlevdato',
        'twentyfourseven_id',
        'Internalid',
        'Internaledit',
        'Internaldel',
        'Internalincmva',
        'Internaltype',
        'Objektid',
        'Enhetskode',
        'Hbversion',
        'eurokurs'
      ]

      let retval = {
        Fakturadato: this.isAccounting && this.form.Fakturadato ? moment(new Date(Date.parse(this.form.Fakturadato))).format('YYYY-MM-DD 00:00:00') : null,
        Forfallsdato: this.form.Forfallsdato ? moment(new Date(Date.parse(this.form.Forfallsdato))).format('YYYY-MM-DD 00:00:00') : null,
        Bilagstype: this.data.Bilagstype,
        PaymentMethod: this.form.PaymentMethod,
        Export: this.data.Export,
        Mvafri: this.data.Mvafri,
        Retur: this.data.Retur,
        type: 'normal'
      }

      if (this.state.editableAs === 'underhand') {
        retval.type = 'underhand'
        retval.objektdata = this._.omit(this.form.objektdata, [ 'MottakerName', 'MottakerObject' ])
      }

      let stripped = []
      this.lines.forEach((line) => {
        stripped.push(this._.omit(line, omitInLine))
      })

      retval.objektlist = []

      retval.objektlist.push({
        Objekt: this.objekt.Objektid,
        bilaglines: stripped
      })

      return retval
    },
    openBilagPdfModal: function (bilag) {
      // Close current modal...
      this.closeModal()
      showBilagEmailPdfModal(this.form.PaymentMethod, bilag)
    },
    handleSubmit: function (utlever = false) {
      var vm = this

      if (!this.isFormSubmittable()) {
        return
      }

      this.deliverButton = utlever

      this.setFormProcessing(true)

      // Make sure mottaker is set
      if (this.state.editableAs === 'underhand') {
        // Reset mottaker name if no mottaker id is set
        if (!this.form.objektdata.Mottaker) {
          this.form.objektdata.MottakerName = null
        }
      }

      setTimeout(function () {
        vm.$validator.validateAll()
          .then((result) => {
            if (!result) {
              // Validation Failed
              if (vm.form.objektdata.MottakerObject.Kundenr == null) {
                vm.$helpers.showErrorAlert('Feil', 'Du må velge en kjøper.')
              } else if (vm.invoiceAddress == null) {
                vm.$helpers.showErrorAlert('Feil', 'Kjøper mangler fakturaddresse.')
              } else if (vm.postAddress == null) {
                vm.$helpers.showErrorAlert('Feil', 'Kjøper mangler leveringsadresse.')
              } else if (vm.form.PaymentMethod == null) {
                vm.$helpers.showErrorAlert('Feil', 'Du må velge betalingsmetode.')
              } else {
                vm.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil')
              }

              setTimeout(function () {
                vm.setFormProcessing(false)
              }, 750)
            } else if (!vm.isValidForSave) {
              vm.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil')

              setTimeout(function () {
                vm.setFormProcessing(false)
              }, 750)
            } else {
              let post = vm.makePostData()
              post.utlever = utlever

              ObjektService.saveObjektBilagBuyer(vm.objekt.Objektid, post)
                .then((response) => {
                  // Send event to parent
                  bus.$emit('invoice-created', response.data)

                  // ... and start the PDF modal.
                  vm.openBilagPdfModal(response.data.bilag || null)
                })
                .catch((error) => {
                  console.log('Error From API', error)

                  // See if we have 247 error
                  const twentyfourSevenError = vm.$helpers.getTwentyfourSevenError(error)

                  if (twentyfourSevenError) {
                    vm.$helpers.showErrorAlert('Kunne ikke lagre faktura', twentyfourSevenError)
                  } else {
                    vm.$helpers.sendApiErrorsToValidator(error, vm.errors)

                    // Check if new errors appeared
                    if (vm.errors.any()) {
                      vm.$validator.resume()
                      vm.$helpers.showErrorAlert('Kunne ikke lagre faktura', 'Vennligst korriger feil i skjemaet')
                    } else {
                      vm.$helpers.showErrorAlert('Kunne ikke lagre faktura', 'Vennligst prøv igjen', 2500)
                    }
                  }
                })
                .then(() => {
                  vm.setFormProcessing(false)
                })
            }
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabKjoperBilagModal.vue